import dayjs from 'dayjs';
import PureHeading from '../../../common/Heading/PureHeading';
import { Label } from '../../../common/Label/Label';
import { PureSeparator } from '../../compound/Separator/Separator';
import LearningLink from '../LearningLink/LearningLink';
import { classes } from '../../../../lib/utils/cssUtils';
import { useConfig } from '../../../../lib/hooks/config';
import shortenText from '../../../../lib/utils/shortenText';
import { isNil } from '../../../../lib/utils/isNil';
import { HeadingLevel } from '../../../../lib/utils/HeadingMapper';
import { DATE_FORMAT_FALLBACK } from '../../../../lib/constants/globals';
import { ACHIEVEMENT_CARD_LABELS } from '../../../../lib/constants/labelKeys';
import { ACHIEVEMENTS_PARAMS } from '../../../../lib/constants/courses';
import styles from './AchievementsList.module.scss';
import { PureLinkVariant } from '../../../common/Link/PureLink';
import { Role, useRole } from '../../../../lib/context/SessionContext';
import { Api } from '../../../../lib/types/apiSpec';
import { DetailsLinkDestination } from '../../../../lib/hooks/useGetDetailsLink';

const Achievement = ({
  type,
  id,
  originalId,
  title,
  achievementDate,
  compliantTillDate,
  active,
}: Api.AchievementBase) => {
  const { globalDateFormat = DATE_FORMAT_FALLBACK } = useConfig() ?? {};
  const role = useRole();

  return (
    <li>
      <div role="group">
        {isNil(active) || active ? (
          <LearningLink
            originalId={originalId}
            type={type}
            id={id ?? ''}
            name={title}
            status={Api.TrainingStatus.COMPLETED}
          >
            <PureHeading level={HeadingLevel.h3} as={HeadingLevel.h2} className={classes(styles.achievementHeading)}>
              {shortenText(title, { length: ACHIEVEMENTS_PARAMS.TITLE_LIMIT })}
            </PureHeading>
          </LearningLink>
        ) : (
          <PureHeading level={HeadingLevel.h3} as={HeadingLevel.h2} className={classes(styles.achievementHeading)}>
            {shortenText(title, { length: ACHIEVEMENTS_PARAMS.TITLE_LIMIT })}
          </PureHeading>
        )}
        <div className={styles.achievementText}>
          <Label name={ACHIEVEMENT_CARD_LABELS.COMPLETED_TEXT} className={styles.achievementResult} />
          <div className={styles.textSeparator} />
          <span className={styles.achievementCompletionDate}>
            <Label name={ACHIEVEMENT_CARD_LABELS.COMPLETED_DATE} />
            {` ${dayjs(achievementDate).format(globalDateFormat)}`}
          </span>
          {compliantTillDate && (
            <>
              <div className={styles.textSeparator} />
              <span>
                <Label name={ACHIEVEMENT_CARD_LABELS.EXPIRY_DATE} />
                <span className={styles.achievementExpiryDate}>
                  {` ${dayjs(compliantTillDate).format(globalDateFormat)}`}
                </span>
              </span>
            </>
          )}
        </div>
        {isNil(active) || active ? (
          <LearningLink
            originalId={originalId}
            type={type}
            id={id ?? ''}
            name={title}
            status={Api.TrainingStatus.COMPLETED}
            to={role !== Role.LEARNER_MANAGER ? DetailsLinkDestination.LITMOS : DetailsLinkDestination.INTERNAL}
            variant={PureLinkVariant.Link}
            card
          />
        ) : (
          <Label name={ACHIEVEMENT_CARD_LABELS.NOT_ACTIVE} className={styles.achievementNotActive} />
        )}
      </div>
      <PureSeparator className={styles.separator} asDiv />
    </li>
  );
};

export default Achievement;
